<template>
  <Catalogs
    title="Должности"
    create-text="Новая"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'JobTitleAdd'"
    :route-edit="'JobTitleEdit'"
    :route-view="'JobTitleView'"
    :route-path="'/job_titles'"
    :can-edit="canEditJobTitleCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "JobTitles",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'job-title-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'short_name',
          label: "Короткое название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'job-title-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getJobTitles(data);
    },
    canEditJobTitleCatalogs() {
      return this.hasPermission([PERM.CATALOG_JOB_TITLE_EDIT]);
    }
  }
}
</script>

<style>
.job-title-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.job-title-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobTitles/JobTitles.vue